import { graphql } from 'gatsby';

import PsyLandingPage from '../../containers/psy-landing-page';

export default PsyLandingPage;

export const query = graphql`
  query {
    backgroundImage: file(relativePath: { eq: "games/3/background.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    ministry: file(relativePath: { eq: "games/3/ministry.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logo: file(relativePath: { eq: "games/3/logo.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
